module.exports = __webpack_public_path__ + "img/ddos-image.1f031df.svg";